import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Popup } from ".";
import { closeIcon } from "../../../assets/icons";
import { generateMFACodeRequest, resetGenerateMFACode } from "../store/generateMFACode.slice";
import { resetValidateMFACode, validateMFACodeRequest } from "../store/validateMFACode.slice";
import { useLegacySupport } from "../../../components";




interface GenerateMFAInterface {
    token: string;
    onClose: () => void;
}

const GenerateMFAModal: React.FC<GenerateMFAInterface> = ({
    token,
    onClose
}) => {
    const dispatch = useDispatch();
    const legacy = useLegacySupport();

    const generateMFACodeData: any = useSelector<any>((state) => state.generateMFACodeData);
    const validateMFACodeData: any = useSelector<any>((state) => state.validateMFACodeData);
    const [data, setData] = useState<any>(null);
    const [isValidate, setIsValidate] = useState<boolean>(false);

    useEffect(() => {
        try {
            let obj: any = { token: legacy.token };
            dispatch(generateMFACodeRequest(obj));
        }catch (e) {
            console.error("Error generating MFA code:", e);
        }
    }, [])


    useEffect(() => {
        if (generateMFACodeData.isSuccess && generateMFACodeData.data !== null) {
            setData(generateMFACodeData.data.data);
            // debugger statement removed
            dispatch(resetGenerateMFACode());
        } else if (generateMFACodeData.isError) {
            toast.error("Internal Server Error");
            dispatch(resetGenerateMFACode());
        }


        if (validateMFACodeData.isSuccess && validateMFACodeData.data !== null) {
            toast.success(validateMFACodeData.data.data);
            setIsValidate(false);
            onClose();
            dispatch(resetValidateMFACode());
        } else if (validateMFACodeData.isError) {
            toast.error("Failed to validate MFA code.");
            setIsValidate(false);
            onClose();
            dispatch(resetValidateMFACode());
        }
    }, [generateMFACodeData, validateMFACodeData]);

    const __renderTitle = () => {
        return (
            <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Generate QR Code</h5>
                <button className="btn btn-transparent close" onClick={() => {
                    onClose();
                }} >
                    <img src={closeIcon} alt="close" />
                </button>
            </div>
        );
    }


    const __onContinue = () => {
        setIsValidate(true);
        // const payload = {
        //     qrCode: data.qrCode,
        //     token: data.token
        // };
        // dispatch(validateMFACodeRequest())

    };

    const __onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const code = formData.get("code") as string;

        if (code.trim() === "") {
            toast.error("Please enter the MFA code.");
            return;
        }

        const payload:any = {
            token: legacy.token,
            code: code
        };

        console.log("Payload for MFA validation:", payload);
        dispatch(validateMFACodeRequest(payload));
    };

    // function to render the fields for the popup of passcode validation
    const __renderContent = () => {

        if(isValidate) {
            return (
                <div className="validation-message px-3 py-3">
                    <form onSubmit={__onSubmit}>
                        <p>Please enter the MFA code show on your device:</p>
                        <input type="text" name="code" placeholder="Enter the code" className="form-control" />
                        <button className="btn btn-primary btn-lg mt-3">Validate Code</button>
                    </form>
                </div>
            );
        }


        return (
            <div className="generate-mfa-content text-center pb-5">
                <div>
                    <img src={data?.qrImage} alt="QR Code" className="qr-code" />
                    <p>{data.qrCode}</p>
                </div>
                <button onClick={__onContinue} className="btn btn-block btn-primary btn-lg">
                    Continue
                </button>
            </div>
        );
    };



    return (<div className="xan-modal">
        <div
            className="modal fade show"
            id="exampleModal"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    {__renderTitle()}

                    <div className="modal-body">
                        {
                            generateMFACodeData.isFetching ?
                                <div className="loader-wrapper">
                                    <div className="loader"></div>
                                </div> :
                                data !== null &&
                                __renderContent()
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>)
}

export default GenerateMFAModal;